export default __webpack_public_path__ + "static/media/What-we-do-Landing page-MobileApp.7d44fb08.png";